// `/c/{slug}/setup/agents/deploy` (DC-11's "Deploy an agent") redirects to the one "Add digital
// employee" flow (DE-WIZARD, review #12: `/setup/des/new`, whose template step offers the
// self-serve templates to the owner or an admin with the `agents` add-on). Old links and
// bookmarks keep working; the history entry is replaced.
import { createRoute, redirect } from "@tanstack/react-router";
import { setupRoute } from "./c.$slug.setup";

export const setupDeployAgentRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "agents/deploy",
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/c/$slug/setup/des/new", params, replace: true });
  },
});
